export const showNewFeatureForLocal = (): boolean =>
	process.env.NEXT_PUBLIC_NSK_ENV === "development";

export const showNewFeatureExcludePrd = (): boolean =>
	process.env.NEXT_PUBLIC_NSK_ENV !== "production";

export const showNewFeatureForLocalOrStagingAdmin = (
	isAdmin: boolean
): boolean =>
	showNewFeatureForLocal() ||
	(process.env.NEXT_PUBLIC_NSK_ENV === "staging" && isAdmin);
